<template>
    <div class="container" id="invoice-content" :style="{backgroundColor: Theme['gray-100']}">
        <div class="content">
            <div id="invoice-content1">
                <div class="d-flex justify-content-between mb-8">
                    <div class="text-start pe-5">
                        <h5>{{ company?.society?.name?.toUpperCase() }}</h5>
                        <p>{{ company?.society?.address }} , {{ company?.society?.city }}, {{ company?.country?.name }}
                            <br>{{ company?.society?.society_email }}
                            <br>{{ company?.society?.society_phone }} 
                            <br>N° IFU {{ company?.society?.ifu_number }} 
                            <br>N° RCCM {{ company?.society?.rccm_number }}
                        </p>
                        <h4>{{ invoice?.invoice_status === 'CREDITNOTE' ? $t('invoice.credit_not_title') : sold ? $t('invoices.invoiceSold')  : $t('invoice.invoice_title') }} N° {{ invoice?.invoice_number }}</h4>
                        <h4  v-if="invoice?.invoice_status === 'CREDITNOTE'">{{  $t('invoice.invoice_title') }} N° {{ invoice?.original_invoice_number }}</h4>
                        <p class="otherStyle mt-3">{{ $t('invoices.date_creation') + ': ' + formatDate(new Date(invoice?.invoice_date))  }}</p>
                    </div>
                    <div class="text-end" style="text-align: right;">
                        <div class="py-10 mb-5" v-if="company?.society?.logo_url">
                            <img :src="company?.society?.logo_url" alt="Logo" style="width: 100px; height: auto;">
                        </div>
                        <p>{{$t('invoices.to')}}
                            <br><span class="fw-bolder">{{ invoice?.contact?.fullname }}</span>
                            <br>{{ contactPhone }}
                            <br>{{ invoice?.contact?.email }}
                        </p>
                    </div>
                </div>
                <div style="min-height: 400px;">
                    <div class="table-responsive">
                        <table class="table text-center mb-5">
                            <thead>
                                <tr>
                                    <th>N°</th>
                                    <th>{{$t('invoices.designation')}}</th>
                                    <th>{{$t('invoices.qty')}}</th>
                                    <th>{{$t('invoices.price')}}</th>
                                    <th>{{$t('invoices.rem')}}</th>
                                    <th>{{$t('invoices.taxes')}}</th>
                                    <th>{{$t('invoices.amount')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <Item v-for="(item, index) in invoice?.items" :key="index" :item="item" :index="index" :currency="invoice?.currency?.symbol"/>
                            </tbody>
                        </table>
                    </div>
                    <div class="d-flex justify-content-between otherStyle">
                        <div class="flex-item py-5 flex-column" style="background-color: #fff;">
                            <div class="d-flex justify-content-between">
                                <div class="text-start ps-3">
                                    {{ $t('invoices.totalTax') }}
                                </div>
                                <div class="text-start pe-6">
                                    {{ $formatLocalAmount(parseFloat(invoice.invoice_total_tax))  }} {{ invoice?.currency?.symbol }}
                                </div>
                            </div>
                        </div>
                        <div class="spacer"></div>
                        <div class="flex-item py-5 flex-column" style="background-color: #fff;">
                            <div class="d-flex justify-content-between">
                                <div class="text-start ps-3">
                                    {{ $t('invoices.subtotal') }}
                                </div>
                                <div class="text-start pe-6">
                                    {{ $formatLocalAmount(parseFloat(invoice.sub_total))  }} {{ invoice?.currency?.symbol }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between py-3 otherStyle">
                        <div class="flex-item py-5 flex-column" style="background-color: #fff;">
                            <div class="d-flex justify-content-between">
                                <div class="text-start ps-3">
                                    {{ $t('invoices.totalRem') }}
                                </div>
                                <div class="text-start pe-6">
                                    {{ $formatLocalAmount(parseFloat(invoice.invoice_discount_value))  }} {{ invoice?.currency?.symbol }}
                                </div>
                            </div>
                        </div>
                        <div class="spacer"></div>
                        <div class="flex-item py-5 flex-column" style="background-color: #fff;">
                            <div class="d-flex justify-content-between">
                                <div class="text-start ps-3">
                                    {{ $t('invoices.totalTtc') }}
                                </div>
                                <div class="text-start pe-6">
                                    {{ $formatLocalAmount(parseFloat(invoice.total))  }} {{ invoice?.currency?.symbol }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between mb-2">
                        <div class="flex-item py-5 otherStyle flex-column" >
                        </div>
                        <div class="spacer"></div>
                        <div class="flex-item py-5 flex-column" style="background-color: var(--bs-primary); color: #fff;">
                            <div class="d-flex justify-content-between">
                                <div class="text-start ps-3">
                                    {{ $t('invoices.total') }}
                                </div>
                                <div class="text-start pe-6">
                                {{ $formatLocalAmount(parseFloat(invoice.total))  }} {{ invoice?.currency?.symbol }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <table class="table text-center mb-5" v-if="sold">
                        <thead>
                            <tr>
                                <th>N°</th>
                                <th class="text-start">{{$t('invoices.advance_sold')}}</th>
                                <th class="text-end pe-6">{{$t('invoices.amount')}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(invoiceAdvance, index) in availableAdvance">
                                <td>{{ index+1 }}</td>
                                <td class="text-start">{{$t('crm.payments.advance_ref', { number: invoiceAdvance.advance_number, percentage: invoiceAdvance.percentage })}}%</td>
                                <td class="text-end pe-6">{{ $formatLocalAmount(parseFloat(invoiceAdvance?.amount))  }} {{invoice?.currency?.symbol }}</td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="table text-center mb-5" v-if="availableAdvance?.length > 0 && !sold">
                        <thead>
                            <tr>
                                <th>N°</th>
                                <th class="text-start">{{$t('payment.advance')}}</th>
                                <th class="text-end pe-6">{{$t('invoices.amount')}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>01</td>
                                <td class="text-start">{{$t('crm.payments.advance_ref', { number: advance.advance_number, percentage: advance.percentage })}}%</td>
                                <td class="text-end pe-6">{{ $formatLocalAmount(parseFloat(advance?.amount))  }} {{invoice?.currency?.symbol }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div id="invoice-content2">
              <slot name="normalizeData" />
              <div class="d-flex justify-content-between mt-10" v-if="invoice?.paymentCondition">
                  <div class="text-start pe-5">
                      <h4 style="color: #F07817;">{{ $t('invoices.terms') }}</h4>
                      <div>
                          <span v-if="invoice?.paymentCondition?.name" style="font-weight: 500;">{{$t('crm.estimate.label.paymentCondition')}} : {{ invoice?.paymentCondition?.name }}</span>
                          <br><span v-if="invoice?.paymentType?.name" style="font-weight: 500;"> {{$t('invoices.label.paymentType')}} : {{ invoice?.paymentType?.name }} </span>
                      </div>
                  </div>
              </div>
            </div>
        </div>
        <div class="pt-5" id="invoice-content3" :style="{borderTop: '1px solid '+Theme['gray-300']}">
            <div class="d-flex text-start mb-3">
                <span class="fw-bold me-2" v-if="company?.society?.headquarters_address">{{ $t('company.label.headquarters_address') }}: {{ company?.society?.headquarters_address }} / </span>
                <span class="fw-bold" v-if="company?.society?.address">{{ company?.society?.address }}</span>
                <span class="fw-bold me-1" v-if="company?.society?.city">, {{ company?.society?.city }} </span>
                <span class="fw-bold" v-if="company?.country?.name"> {{ company?.country?.name }}</span>
                <span class="fw-bold" v-if="company?.website"> / {{ company?.website }}</span>
            </div>
            <div class="d-flex text-start">
                <span v-if="company?.bankData?.bank_name" class="fw-bold me-2">{{ company?.bankData?.bank_name }} </span>
                <span v-if="company?.bankData?.bic" class="fw-bold me-2">{{ $t('bank.label.bic')?.toUpperCase() }}: {{ company?.bankData?.bic }} </span>
                <span v-if="company?.bankData?.rib" class="fw-bold me-2">{{ $t('bank.label.rib')?.toUpperCase() }}: {{ company?.bankData?.rib }} </span>
                <span v-if="company?.bankData?.iban" class="fw-bold">{{ $t('bank.label.iban')?.toUpperCase() }}: {{ company?.bankData?.iban }}</span>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { Theme } from "@/composables/theming";
    import {computed, defineProps} from 'vue'
    import {useStore} from "vuex";
    import {useLocales} from "@/composables/locales";
    import {formatDate, $formatLocalAmount} from "@/mixins/Helpers";
    import Item from "./Item";

    const { locale } = useLocales()
    const store = useStore()

    const props = defineProps({
        cancel: {type: Boolean, default: false},
        sold: {type: Boolean, default: false},
        invoice: { type: Object, required: true }
    })

    const company = computed(() => store.getters['company/getCompanyInfos'])
    const availableAdvance = computed(() => {
        let data = props.invoice?.advances?.filter(item => item.status == 'UNPAID' || item.status == 'PAID')
        return data
    })
    const advance = computed(() => availableAdvance.value?.length > 0 ? availableAdvance.value[0] : {})

    const contactPhone = computed(() => {
        if (props.invoice?.contact?.phone) {
            try {
                const phones = props.invoice.contact.phone;
                if (phones.length) {
                    return phones[0];
                }
            } catch (error) {
                console.error('Error parsing phone data:', error);
            }
        }
        return '';
    });
</script>

<style scoped>
  .container {
    width: 100%;
    max-width: 800px;
    margin: 20px auto;
    border: 1px solid #e0e0e0;
    border-radius: 5px;
  }
  .table th {
    background-color: var(--bs-primary);
    color: #ffffff;
  }
  .table tr {
    background-color: #fff;
    margin-bottom: 5px;
    border-bottom: 3px solid #F2F3F4;
  }
  .otherStyle{
      color: var(--bs-primary);
      font-weight: 500;
  }
  .flex-item {
       flex: 1;
   }
   .spacer {
       min-width: 20px;
   }
</style>